import axios from "axios"
import { getToken } from "./token"

const http = axios.create({
    // baseURL: 'http://192.168.10.152:8060',//测试环境立方
  // baseURL: 'http://192.168.10.230:9092',//测试环境
  baseURL: 'http://nawlwapi.mhksd.com.cn:8891', //正式环境
    timeout: 5000,

})
// 请求拦截器
http.interceptors.request.use((config) => {
    // 一存多用 token注入
    const token = getToken()
    if (token) {
        config.headers.apitoken = token
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

//响应拦截器
http.interceptors.response.use((response) => {
    if (response.data.msg === "token无效") {
        window.location.href = '/Login'
    }
    return response
}, (error) => {
    return Promise.reject(error)
})

export { http }